<template>
    <div>
        <div class="form-info">
            <div class="content-caption dashed">
                <span>信息单</span>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>名称</label>
                </div>
                <div class="form-value">
                    <span>{{devcInfoForm.name}}</span>
                </div>
            </div>
            <div class="content-caption dashed" style="margin-top: 50px;">
                <span>信息单项</span>
            </div>
            <el-table :data="devcInfoForm.itemList" border style="width: 100%">
                <el-table-column prop="label" label="标签" align="left" width="500"></el-table-column>
                <el-table-column prop="value" label="内容" align="left"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-devc-info-form-detail',
        desc: '设备信息单详情',
        props: {
            id: {
                type: Number,
                deafult: null
            }
        },
        data: function () {
            return {
                devcInfoForm: {
                    name: null,
                    itemList: []
                }
            }
        },
        created: function () {
            this.getDevcInfoForm();
        },
        methods: {
            getDevcInfoForm(){
                let self = this;
                let postData = {};
                postData.id = this.id;
                let theLoading = MsgBox.loading();
                shopDevcApi.getDevcInfoForm(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.devcInfoForm = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DevcInfoFormDetail.vue